import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import NotFound from './views/NotFound.vue'
import EnhancedModelPage from './views/EnhancedModelPage.vue'
import ModelResearchPage from './views/ModelResearchPage.vue'
import App from './App.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:year/:make/:model',
    name: 'model-details-short',
    component: App,
  },
  {
    path: '/models/:year/:make/:model',
    name: 'model-details',
    component: App,
  },
  {
    path: '/enhanced/:year/:make/:model',
    name: 'enhanced-model-details',
    component: EnhancedModelPage,
  },
  {
    path: '/enhanced/models/:year/:make/:model',
    name: 'enhanced-model-details-full',
    component: EnhancedModelPage,
  },
  {
    path: '/research/:year/:make/:model',
    name: 'model-research',
    component: ModelResearchPage,
  },
  {
    path: '/research/models/:year/:make/:model',
    name: 'model-research-full',
    component: ModelResearchPage,
  },
  {
    path: '/',
    name: 'home',
    redirect: 'not-found',
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
